<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12">
            <v-card :loading="loading">
              <v-card-text class="py-0 pt-5 pb-5">
                <!-- Error Alert -->
                <v-alert
                  v-if="errorAlertVisible"
                  color="red"
                  shaped
                  type="error"
                  dismissible
                  @input="errorAlertVisible = false"
                >
                  {{ arabic ? 'حدث خطاء اثناء  ترحيل الطلب الى نينجا ' : 'An error occurred while relaying the request to Ninja' }}
                </v-alert>

                <!-- Success Alert -->
                <v-alert
                  v-if="successAlertVisible"
                  color="green"
                  shaped
                  type="success"
                  dismissible
                  @input="successAlertVisible = false"
                >
                  {{ arabic ? 'تمت عملية الترحيل الى نينجا  بنجاح' : 'The migration to Ninja was completed successfully.' }}
                </v-alert>

                <!-- List of results -->
                <div>
                  <div class="text-center my-3">
                    <v-btn color="success" :loading="loading" text small @click="reload()">
                      {{ i18n['reload'] }}
                    </v-btn>
                  </div>
                  <v-container>

                    <v-pagination
                    v-model="currentPage"
                     :total-visible="7"
                    :length="totalPages"
                    @input="fetchNinjaProducts"
                  ></v-pagination>

                  </v-container>
               

                  <v-simple-table v-if="ninjaProducts && ninjaProducts.length > 0">
                    <thead>
                      <tr>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'SKU' : 'SKU' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'اسم المنتج' : 'Item Name' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'صورة المنتج' : 'Item Image' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'Action' : 'Action' }}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(result) in ninjaProducts" :key="result.id">
                        <td>{{ result.sku }}</td>
                        <td>{{ result.name }}</td>
                        <td>
                          <img
                            :src="result.images && result.images.length > 0 ? result.images[0].url : ''"
                            alt="Product Image"
                            width="50"
                          />
                        </td>
                        <td>
                          <v-btn x-small color="success" @click="zidIsSync(result.id)">Zid Sync</v-btn>
                          <v-btn x-small color="success" @click="sallaIsSync(result.id)">Salla Sync</v-btn>

                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>

                  <v-simple-table v-else>
                    <tbody>
                      <tr>
                        <td colspan="4" class="text-center">No products available</td>
                      </tr>
                    </tbody>
                  </v-simple-table>

                  <!-- Pagination Component -->
                  <v-pagination
                    v-model="currentPage"
                    :total-visible="7"
                    :length="totalPages"
                    @input="fetchNinjaProducts"
                  ></v-pagination>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      results: [],
      filterCriteria: {
        inputSearch: '',
        fromDate: '',
        toDate: '',
        is_sync: null,
      },
      currentPage: 1, 
      limit: 10,
      totalPages: 0, 
      loading: false,
      showDialog: false,
      ninjaProducts: [],
      is_subscription: false,
      alertVisible: false,
      alertMessage: '',
      errorAlertVisible: false,
      successAlertVisible: false,
      user: null, // To store user data
    };
  },
  methods: {
    async zidIsSync(id_product) {
    //  alert(id_product);
    const accountId = this.user.account.id;

      try {
        this.loading = true;
        const response = await this.$store.dispatch('getResource', {
          resource: `/apps/zid/products/push?account_id=${accountId}&id=${id_product}`,
        });
        this.loading = false;

        if (response.status === 'success') {
          this.successAlertVisible = true;
          this.errorAlertVisible = false;
          this.alertMessage = response.message;
          console.log('Response data:', this.alertMessage);
        } else if (response.status === 'error') {
          this.errorAlertVisible = true;
          this.successAlertVisible = false;
          this.alertMessage = response.message;
          console.log('Response data:', this.alertMessage);
        }
        this.fetchNinjaProducts();
      } catch (error) {
        this.loading = false;
        this.errorAlertVisible = true;
        this.successAlertVisible = false;
        this.alertMessage = error.message;
        console.error('Error:', error.message);
        this.fetchNinjaProducts();
      }
    },
    async fetchUser() {
      try {
        this.user = await this.$store.dispatch('getUser');
        console.log('User data fetched:', this.user);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    },

    async sallaIsSync(id_product) {
      // alert(id_product);
      try {
        const accountId = this.user.account.id;
        this.loading = true;
        const response = await this.$store.dispatch('getResource', {
          resource: `/apps/salla/products/push?account_id=${accountId}&id=${id_product}`,
        });
        this.loading = false;

        if (response.status === 'success') {
          this.successAlertVisible = true;
          this.errorAlertVisible = false;
          this.alertMessage = response.message;
          console.log('Response data:', this.alertMessage);
        } else if (response.status === 'error') {
          this.errorAlertVisible = true;
          this.successAlertVisible = false;
          this.alertMessage = response.message;
          console.log('Response data:', this.alertMessage);
        }
        this.fetchNinjaProducts();
      } catch (error) {
        this.loading = false;
        this.errorAlertVisible = true;
        this.successAlertVisible = false;
        this.alertMessage = error.message;
        console.error('Error:', error.message);
        this.fetchNinjaProducts();
      }
    },
    async checkSubscription() {
      try {
        const response = await this.$store.dispatch('getResource', {
          resource: '/checkSubscription',
        });
        if (response && response.status) {
          this.is_subscription = response.status === 'is_active';
          console.log('Subscription status:', this.is_subscription ? 'Active' : 'Inactive');
        } else {
          console.log('No subscription status found in the response.');
          this.is_subscription = false;
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        this.is_subscription = false;
      }
    },
    async fetchNinjaProducts() {
      this.loading = true;
      try {
        const accountId = this.user.account.id;
// alert(accountId)
        const response = await this.$store.dispatch('getResource', {
          resource: `/apps/get-products?account_id=${accountId}&page=${this.currentPage}`,
        });

        console.log('API Response:', response);
        
        if (response && response) {
          if (Array.isArray(response.data)) {
            this.ninjaProducts = response.data;
            this.totalPages = response.per_page || 1; 
          } else {
            console.error('Expected an array for response.data but got:', response.data);
            this.ninjaProducts = [];
            this.totalPages = 1;
          }
        } else {
          console.error('Response or response.data is undefined:', response);
          this.ninjaProducts = [];
          this.totalPages = 1;
        }
      } catch (error) {
        console.error('Error fetching form results:', error);
        this.ninjaProducts = [];
        this.totalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    async reload() {
      this.fetchNinjaProducts();
    },
    formatDate(dateString) {
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    navigateToPlanPrice() {
      this.$router.push({ name: 'plan_price' });
    },
  },
  mounted: async function () {
  // Fetch the user first
  await this.fetchUser();

  // Now, fetch products once the user is guaranteed to be loaded
  this.fetchNinjaProducts();
  // this.checkSubscription();  // If needed, you can call other dependent methods here as well
},
  computed: {
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      return this.$store.state.language === 'ar';
    },
  },
};
</script>

<!-- <style scoped>
/* Add your styles here */
</style> -->